import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { IOSLoadingSpinner } from './IOSLoadingSpinner';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center ios-glass animate-fade-in">
        <div className="flex flex-col items-center gap-4">
          <IOSLoadingSpinner size="lg" />
          <p className="ios-caption animate-pulse">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return <div className="ios-page-transition">{children}</div>;
};
